"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**********************************************************************************/
// From slate's examples
// https://github.com/ianstormtaylor/slate/blob/master/examples/paste-html/index.js

/**********************************************************************************/


var BLOCK_TAGS = {
  p: 'paragraph',
  li: 'list-item',
  ul: 'bulleted-list',
  ol: 'numbered-list',
  blockquote: 'quote',
  pre: 'code',
  h1: 'heading-one',
  h2: 'heading-two',
  h3: 'heading-three',
  h4: 'heading-four',
  h5: 'heading-five',
  h6: 'heading-six'
};
var MARK_TAGS = {
  strong: 'bold',
  em: 'italic',
  u: 'underline',
  s: 'strikethrough',
  code: 'code'
};
var RULES = [{
  deserialize: function deserialize(el, next) {
    var block = BLOCK_TAGS[el.tagName.toLowerCase()];

    if (block) {
      return {
        object: 'block',
        type: block,
        nodes: next(el.childNodes)
      };
    }
  },
  serialize: function serialize(obj, children) {
    if (obj.object === 'block') {
      switch (obj.type) {
        case 'code':
          return _react["default"].createElement("pre", null, _react["default"].createElement("code", null, children));

        case 'paragraph':
          return _react["default"].createElement("p", {
            className: obj.data.get('className')
          }, children);

        case 'quote':
          return _react["default"].createElement("blockquote", null, children);

        default:
          return _react["default"].createElement("p", null, children);
      }
    }
  }
}, {
  deserialize: function deserialize(el, next) {
    var mark = MARK_TAGS[el.tagName.toLowerCase()];

    if (mark) {
      return {
        object: 'mark',
        type: mark,
        nodes: next(el.childNodes)
      };
    }
  },
  serialize: function serialize(obj, children) {
    if (obj.object === 'mark') {
      switch (obj.type) {
        case 'bold':
          return _react["default"].createElement("strong", null, children);

        case 'italic':
          return _react["default"].createElement("em", null, children);

        case 'underline':
          return _react["default"].createElement("u", null, children);

        case 'code':
          return _react["default"].createElement("code", null, children);

        default:
          return _react["default"].createElement("p", null, children);
      }
    }
  }
}, {
  // Special case for code blocks, which need to grab the nested childNodes.
  deserialize: function deserialize(el, next) {
    if (el.tagName.toLowerCase() === 'pre') {
      var code = el.childNodes[0];
      var childNodes = code && code.tagName.toLowerCase() === 'code' ? code.childNodes : el.childNodes;
      return {
        object: 'block',
        type: 'code',
        nodes: next(childNodes)
      };
    }
  }
}, {
  // Special case for images, to grab their src.
  deserialize: function deserialize(el, next) {
    if (el.tagName.toLowerCase() === 'img') {
      return {
        object: 'block',
        type: 'image',
        nodes: next(el.childNodes),
        data: {
          src: el.getAttribute('src')
        }
      };
    }
  }
}, {
  // Special case for links, to grab their href.
  deserialize: function deserialize(el, next) {
    if (el.tagName.toLowerCase() === 'a') {
      return {
        object: 'inline',
        type: 'link',
        nodes: next(el.childNodes),
        data: {
          href: el.getAttribute('href')
        }
      };
    }
  }
}];
var _default = RULES;
exports["default"] = _default;